export default __webpack_public_path__ + "static/media/imagePlaceholder.edf55e50.svg";